/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import elementSize from '../../../modules/ajio-util/dom/elementSize.js';
import { getPageDescription } from './../../../utils/plpMetaInfo.js';
import Dialog from '../../../refresh/molecules/Dialog';

class TopDescription extends React.Component {
  constructor(props) {
    super(props);
    this.seoInfoContent = null;
    this.state = {
      readMoreModal: false,
      readMoreClicked: false,
      showReadMore: false,
      maxHgt: '26px',
      categoryforheader: '',
      searchedData: '',
    };
  }
  expandCollapse() {
    this.setState({ readMoreClicked: !this.state.readMoreClicked });
  }
  updateModalState = () => {
    this.setState(prevState => {
      return {
        readMoreModal: !prevState.readMoreModal
      };
    });
  };
  handleReadMoreAction = () => {
    let { deviceType = '' } = this.props;
    deviceType === 'mobile' ? this.updateModalState() : this.expandCollapse();
  };

  componentDidMount() {
    const { height = 0, lineHeight = 0 } = elementSize(this.seoInfoContent) || {};
    if (Math.floor(height / lineHeight) > 3) {
      this.setState({ showReadMore: true });
      this.setState({ maxHgt: lineHeight * 3 + 1 });
    }
  }

updateAriaLabels = (htmlString) => {
  try {
    if (!htmlString || typeof htmlString !== "string") return "";

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    if (!doc) return htmlString; // fallback: return original string

    const anchorTags = doc.querySelectorAll("a") || [];
    const { categoryforheader = "", searchedData = "" } = this.props || {};
    const categoryContext = [categoryforheader?.trim(), searchedData?.trim()]
      .filter(Boolean)
      .join(" ");

    anchorTags.forEach((aTag) => {
      if (!aTag) return;

      const href = aTag.getAttribute("href") || "";
      const text = aTag.textContent?.trim();
      if (!text) return;

      let labelPrefix = "";
      if (href.includes("/b/")) {
        labelPrefix = "Brand";
      } else if (href.includes("/c/")) {
        labelPrefix = "Category";
      } else if (href.includes("/find/")) {
        labelPrefix = "Type";
      }

      if (labelPrefix) {
        aTag.setAttribute("aria-label", `${categoryContext} ; ${labelPrefix} ${text}`);
      }
    });

    return doc.body?.innerHTML || htmlString;
  } catch (error) {
    console.error("updateAriaLabels failed:", error);
    return htmlString; // fallback to original string
  }
};

  render() {
    let {
      categoryDescription = '',
      topdescription = '',
      metaElementData = [],
      deviceType = '',
      categoryName = '',
      newDesignLuxe,
      isDeal,
      categoryforheader = '',
      searchedData = '',
    } = this.props;
    // console.log("@@@@@@@@@@@@@", categoryName, "!!!!!!!!!!!!!!!", categoryDescription)

    const currentLocation = window?.location?.pathname?.startsWith('/s');
    const params = new URLSearchParams(window.location.search);
    const isCuratedWidget = params.has('isCuratedWidget', true)
    const curatedDescription = currentLocation ? getPageDescription(metaElementData) : '';
    categoryDescription = curatedDescription || categoryDescription || topdescription;
    let readMoreLink, readLessLink;
    const contextLabel = [categoryforheader.trim(), searchedData.trim()].filter(Boolean).join(' ');

    if (newDesignLuxe) {
      readMoreLink = (
        <a className="plp-info-description-viewmore" onClick={this.handleReadMoreAction} tabIndex={0} aria-label={`View more about ${contextLabel}`}>
          {' '}
          View More
        </a>
      );
      readLessLink = (
        <a
          className="plp-info-description-viewless"
          onClick={() => {
            this.expandCollapse();
          }}
          aria-label={`View less about ${contextLabel}`}
          tabIndex={0}
        >
          {' '}
          View Less
        </a>
      );
    } else {
      readMoreLink = <a onClick={this.handleReadMoreAction} tabIndex={0}  aria-label={`Read more about ${contextLabel}`}> Read More</a>;
      readLessLink = (
        <a
          onClick={() => {
            this.expandCollapse();
          }}
          tabIndex={0}
          aria-label={`Read less about ${contextLabel}`}
        >
          {' '}
          Read Less
        </a>
      );
    }
    if (!categoryDescription) {
      return null;
    }
    if (categoryDescription && this.state.readMoreClicked && deviceType !== 'mobile') {
      return (
        <div className="plp-info-description">
          <div dangerouslySetInnerHTML={{ __html: this.updateAriaLabels(categoryDescription) }}></div>
          <div> {readLessLink} </div>
        </div>
      );
    } else {
      let style = {
        maxHeight: this.state.maxHgt + 'px',
        overflow: 'hidden',
        marginTop: isDeal ? '10px' : '0px'
      };
      if(isCuratedWidget){
        return null
      }
      return (
        <div className="plp-info-description">
          <Dialog
            showDialog={this.state.readMoreModal}
            type="drawer"
            onCancel={() => this.updateModalState()}
            ariaLabel="description"
          >
            <div className="plp-info-description">
              <h2>{categoryName}</h2>
              <div
                ref={seoInfoContent => {
                  this.seoInfoContent = seoInfoContent;
                }}
                dangerouslySetInnerHTML={{ __html: this.updateAriaLabels(categoryDescription) }}
              ></div>
            </div>
          </Dialog>
          <div
            ref={seoInfoContent => {
              this.seoInfoContent = seoInfoContent;
            }}
            style={style}
            dangerouslySetInnerHTML={{ __html: this.updateAriaLabels(categoryDescription) }}
          ></div>
          <div> {this.state.showReadMore ? readMoreLink : null} </div>
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  const { productsAdditionalInfo = {} } = state;
  const { categoryDescription, topdescription, metaElementData } = productsAdditionalInfo;
  return {
    categoryDescription,
    topdescription,
    metaElementData
  };
};

export default connect(mapStateToProps)(TopDescription);
